import { setSettings } from '@fantastic-admin/settings'

export default setSettings(
  {
    app: {
      account: {
        auth: true,
      },
      routeBaseOn: 'backend',
      dynamicTitle: true,
      feedback: true,
      lockScreen: true,
      errorLog: true,
      checkUpdates: true,
      copyright: {
        enable: true,
        dates: '2020-present',
        company: 'Fantastic-admin',
        website: 'https://fantastic-admin.hurui.me',
      },
      preferences: {
        theme: true,
        menu: true,
        topbar: true,
        tabbar: true,
        toolbar: true,
        page: true,
      },
    },
    theme: {
      baseColorLight: 'zinc',
      baseColorDark: 'zinc',
      light: 'indigo',
      dark: 'indigo',
      colorScheme: 'light',
      radius: 0.5,
    },
    menu: {
      dark: true,
      style: 'line',
      mainMenuClickMode: 'smart',
      subMenuCollapseButton: true,
      hotkeys: true,
    },
    topbar: {
      tabbar: true,
      mode: 'fixed',
    },
    tabbar: {
      style: 'square',
      minMaxWidth: [
        150,
        200,
      ],
      icon: true,
      memory: true,
      hotkeys: true,
    },
    toolbar: {
      favorites: true,
      breadcrumb: {
        style: '',
        mainMenu: true,
      },
      i18n: {
        defaultLang: 'zh-cn',
      },
      fullscreen: true,
      pageReload: true,
      colorScheme: true,
    },
    page: {
      transitionMode: 'slide-right',
      iframeKeepAliveMax: 9,
    },
  },
)
